let viewmodes = {
    'module-entity-viewmode-default': require('@/components/module/viewmodes/Default.vue').default,
    'module-entity-viewmode-post': require('@/components/module/viewmodes/Post.vue').default,
}

export default viewmodes
